import * as ActionTypes from '../ActionTypes';
const Basket = (state = [], action) => {
  switch (action.type) {
    case ActionTypes.BASKET_ADD:
      console.log(action.payload);
      return state.concat(action.payload);

    case ActionTypes.BASKET_DELETE:
      console.log(action.payload);
      return state.filter((_, index) => {
        return index !== action.payload;
      });
    case ActionTypes.BASKET_EMPTY:
      return [];
    default:
      return state;
  }
};

export default Basket;
